module.exports = __webpack_public_path__ + "media/rugbehandeling.5bfb0c35.mp4";